export default {
    NO_LOGO: 'NO_LOGO',
    DEFAULT_LOGO: 'DEFAULT_LOGO',
    CUSTOM_LOGO: 'CUSTOM_LOGO'
}
